import { ChangeDetectionStrategy, Component, DestroyRef, inject, ViewChild } from '@angular/core';
import { ListCustomCell } from '@shared/modules/list/interfaces/list-custom-cell.interface';
import { ListService } from '@shared/modules/list/services/list.service';
import { debounceTime, tap } from 'rxjs/operators';
import { SharedModule } from '@shared/shared.module';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'project-responsible-client-cell',
  templateUrl: './project-responsible-client-cell.component.html',
  styles: [
    `
      .project-responsible-client-cell {
        width: 100%;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SharedModule]
})
export class ProjectResponsibleClientCellComponent implements ListCustomCell {
  @ViewChild('template') template;

  private destroyRef = inject(DestroyRef);
  private service = inject(ListService);

  ngAfterViewInit() {
    setTimeout(() => {
      this.listenScrollTable();
    }, 1000);
  }

  listenScrollTable() {
    this.service.table.scroll
      .pipe(
        debounceTime(100),
        tap(() => {
          const popover = document.querySelector('mwl-confirmation-popover-window');
          if (popover) popover.remove();
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }
}
